var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.25C14.5858 3.25 14.25 3.58579 14.25 4C14.25 4.41421 14.5858 4.75 15 4.75H18.1893L13.4697 9.46967C13.1768 9.76256 13.1768 10.2374 13.4697 10.5303C13.7626 10.8232 14.2374 10.8232 14.5303 10.5303L19.25 5.81066V9C19.25 9.41421 19.5858 9.75 20 9.75C20.4142 9.75 20.75 9.41421 20.75 9V4C20.75 3.58579 20.4142 3.25 20 3.25H15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0721 14.551L18.5578 15.4796C20.0409 16.4065 20.4501 18.384 19.4567 19.8235L19.0934 20.3499C18.4246 21.319 17.4299 22.0429 16.2532 21.998C14.2388 21.9211 10.7433 21.1055 6.81887 17.1811C2.89449 13.2567 2.07885 9.76118 2.00198 7.7468C1.95708 6.57013 2.68099 5.57544 3.65012 4.9066L4.17653 4.5433C5.616 3.54986 7.59347 3.95907 8.52045 5.44223L9.44896 6.92785C10.0027 7.81377 9.77162 8.97756 8.9215 9.58479C8.26746 10.052 7.80326 10.7726 8.00997 11.5494C8.20087 12.2667 8.65743 13.2351 9.71116 14.2888C10.7649 15.3426 11.7333 15.7991 12.4506 15.99C13.2274 16.1967 13.948 15.7325 14.4152 15.0785C15.0224 14.2284 16.1862 13.9973 17.0721 14.551Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutgoing);
export default __webpack_public_path__ + "static/media/phone-outgoing.192582794f86c169641109aff21b805a.svg";
export { ForwardRef as ReactComponent };